import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c9b287c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "_l_boxs"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "_r_boxs"
};
const _hoisted_4 = {
  class: "text_t"
};
const _hoisted_5 = {
  class: "names"
};
const _hoisted_6 = {
  class: "ic_box"
};
const _hoisted_7 = {
  class: "ic_items"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_items iconfont iconyy-liulan"
}, null, -1));
const _hoisted_9 = {
  class: "text_s"
};
const _hoisted_10 = {
  class: "ic_items",
  style: {
    "margin-left": "17px"
  }
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_items iconfont iconyy-shoucang"
}, null, -1));
const _hoisted_12 = {
  class: "text_s"
};
const _hoisted_13 = {
  class: "ic_items",
  style: {
    "margin-left": "17px"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "font_items iconfont iconyy-fenzhi"
}, null, -1));
const _hoisted_15 = {
  class: "text_s"
};
const _hoisted_16 = {
  class: "time_box"
};
const _hoisted_17 = {
  class: "text_pt"
};
const _hoisted_18 = {
  key: 0,
  class: "_is_top"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons_top iconfont iconyy-tuijian"
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text_s"
}, "已推荐", -1));
const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn_items color_1"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icons iconfont iconyy-chakan"
}), /*#__PURE__*/_createElementVNode("span", null, "预览")], -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons iconfont iconyy-bianji"
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1));
const _hoisted_26 = [_hoisted_24, _hoisted_25];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons iconfont iconyy-shanchu1"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1));
const _hoisted_31 = [_hoisted_29, _hoisted_30];
import { ref, markRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { addCaseApi, deleteCaseApi } from "@/service/modules/case";
import { ElMessage, ElMessageBox } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
import coverDialog from './cover-dialog.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'item-detile',
  props: {
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["close"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const props = __props;
    const isHovered = ref(false);
    const handleMouseEnter = () => {
      isHovered.value = true;
    };
    const handleMouseLeave = () => {
      isHovered.value = false;
    };
    async function set_status() {
      let reqdata = {
        id: props.itemData.id,
        status: props.itemData.status == 1 ? 2 : 1
      };
      const res = await addCaseApi(reqdata);
      if (res.code == 0) {
        props.itemData.status = props.itemData.status == 1 ? 2 : 1;
        ElMessage.success("操作成功");
      }
    }
    async function del_item() {
      ElMessageBox.confirm("该笔记删除后无法恢复，确定要删除吗？", "删除笔记", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteCaseApi(props.itemData.id);
          ElMessage.success("删除成功");
          emit("close");
        } catch {}
      }).catch(() => {});
    }
    async function set_istop() {
      let reqdata = {
        id: props.itemData.id,
        is_top: props.itemData.is_top == 1 ? 0 : 1
      };
      const res = await addCaseApi(reqdata);
      if (res.code == 0) {
        props.itemData.is_top = props.itemData.is_top == 1 ? 0 : 1;
        ElMessage.success("操作成功");
      }
    }
    async function editItem(id) {
      emit("close", id);
    }
    const is_show_l = ref(false);
    async function examine() {
      is_show_l.value = true;
    }
    function closeDialog() {
      is_show_l.value = false;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item-boxs", isHovered.value ? 'bgc_s' : '']),
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        class: _normalizeClass(["images", isHovered.value ? 'images_select' : '']),
        src: __props.itemData.thumb,
        alt: ""
      }, null, 10, _hoisted_2), _withDirectives(_createElementVNode("div", {
        class: "is_tops",
        onClick: set_istop
      }, _toDisplayString(__props.itemData.is_top == 1 ? "取消推荐" : "推荐"), 513), [[_vShow, isHovered.value]])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.itemData.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(__props.itemData.view_num), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(__props.itemData.collect_num), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString(__props.itemData.last_week_view_num), 1)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", {
        class: _normalizeClass(__props.itemData.status == 1 ? 'is_status' : 'is_nostatus')
      }, _toDisplayString(__props.itemData.status == 1 ? "已上架" : "已下架"), 3), _createElementVNode("span", _hoisted_17, _toDisplayString(__props.itemData.ct_time), 1)]), __props.itemData.is_top == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", {
        class: "btn_boxs",
        onClick: _withModifiers(examine, ["stop"])
      }, [_hoisted_23, _createElementVNode("div", {
        class: "btn_items color_2",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => editItem(__props.itemData.id), ["stop"]))
      }, _hoisted_26), _createElementVNode("div", {
        class: "btn_items color_3",
        onClick: _withModifiers(set_status, ["stop"])
      }, [_createElementVNode("i", {
        class: _normalizeClass(["icons iconfont", __props.itemData.status == 1 ? 'iconyy-xiajia' : 'iconyy-shangjia'])
      }, null, 2), _createElementVNode("span", null, _toDisplayString(__props.itemData.status == 1 ? "下架" : "上架"), 1)], 8, _hoisted_27), _createElementVNode("div", {
        class: "btn_items color_4",
        onClick: _withModifiers(del_item, ["stop"])
      }, _hoisted_31, 8, _hoisted_28)], 8, _hoisted_22), [[_vShow, isHovered.value]])]), is_show_l.value ? (_openBlock(), _createBlock(coverDialog, {
        key: 0,
        id: __props.itemData.id,
        onCloseDialog: closeDialog,
        "dialog-visible": is_show_l.value
      }, null, 8, ["id", "dialog-visible"])) : _createCommentVNode("", true)], 34);
    };
  }
});